import { AnimatePresence } from "motion/react";
import { FC, PropsWithChildren, ReactElement, useState } from "react";

import {
  ConflictsCollapseIcon,
  PreviewLineWithArrowStyled,
} from "./common.styled";

interface IExpandedAdornmentProps extends PropsWithChildren {
  NavControl: ReactElement;
  EndAdornment?: ReactElement;
}

export const ExpandedAdornment: FC<IExpandedAdornmentProps> = ({
  children,
  NavControl,
  EndAdornment,
}) => {
  const [isExpanded, setExpanded] = useState(false);
  return (
    <>
      <PreviewLineWithArrowStyled
        onClick={() => setExpanded(isExpandedValue => !isExpandedValue)}
      >
        {NavControl}
        <ConflictsCollapseIcon isExpanded={isExpanded} />
        {EndAdornment}
      </PreviewLineWithArrowStyled>
      <AnimatePresence initial={false}>
        {isExpanded && children}
      </AnimatePresence>
    </>
  );
};
